import { atom } from "jotai";

import type { DeckCommentType, DeckType, DecklistType } from "~/types/deck";
import type { FolderType } from "~/types/folder";

// base
export const deckJotai = atom<DeckType | null>();
export const decklistJotai = atom<DecklistType>();
export const avatarJotai = atom<DecklistType[number]>();
export const sideboardJotai = atom<DecklistType>();
export const maybeboardJotai = atom<DecklistType>();
export const commentsJotai = atom<DeckCommentType[]>();
export const trackingJotai = atom(false);

export const foldersJotai = atom<FolderType[]>();

// resetter
export const deckResetterJotai = atom(null, (_, set) => {
  set(deckJotai, undefined);
  set(decklistJotai, undefined);
  set(avatarJotai, undefined);
  set(sideboardJotai, undefined);
  set(maybeboardJotai, undefined);
  set(commentsJotai, undefined);
  set(trackingJotai, false);
});
